const version = "2.4.4";
export { version };